import React from 'react';
import { MessageSquareIcon, XIcon } from 'lucide-react';
import { useEsosa } from './EsosaContext';
const AssistantButton: React.FC = () => {
  const {
    isOpen,
    toggleAssistant
  } = useEsosa();
  return <button onClick={toggleAssistant} className={`fixed bottom-6 right-6 w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 z-50 ${isOpen ? 'bg-red-500 hover:bg-red-600' : 'bg-green-700 hover:bg-green-800'}`} aria-label={isOpen ? 'Close Esosa Assistant' : 'Open Esosa Assistant'} data-id="element-226">
      {isOpen ? <XIcon className="h-6 w-6 text-white" data-id="element-227" /> : <div className="relative w-full h-full rounded-full overflow-hidden" data-id="element-228">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/oDjpiHBouQ4aF9pkTrtfRi/4962a6aa-ef23-434b-add9-8772d4fb637b.png" alt="Esosa AI Assistant" className="w-full h-full object-cover" data-id="element-229" />
          <div className="absolute bottom-0 left-0 right-0 bg-green-700 bg-opacity-70 py-0.5 text-white text-xs text-center font-medium" data-id="element-230">
            Esosa
          </div>
        </div>}
    </button>;
};
export default AssistantButton;